import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
	play: false,
	codename: 'sound_notification',
	duration: 3000,

};

export const actionTypes = {
	PlaySound: "[PLAY_SOUND] Action",
	StopSound: "[STOP_SOUND] Action",
};

export const reducer = persistReducer(
	{ storage, key: "sound" },
	(state = initialState, action) => {

		const { type, payload } = action;

		switch (type) {
			case actionTypes.PlaySound:
				return {
					play: true,
					codename: payload.codename || initialState.codename,
					duration: payload.duration || initialState.duration,
				};
			case actionTypes.StopSound:
				return initialState;
			default:
				return state;
		}
	}
);

export const actions = {
	playSound: payload => ({ type: actionTypes.PlaySound, payload: payload }),
	stopSound: payload => ({ type: actionTypes.StopSound, payload: payload }),
};
